import { SVGProps, Ref, forwardRef } from 'react';

export const GamepadOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.664 8.532c.605 0 1.11-.21 1.449-.617.32-.384.417-.854.417-1.25 0-.395-.098-.866-.417-1.25-.339-.406-.844-.616-1.45-.616-.605 0-1.11.21-1.448.616-.32.384-.418.855-.418 1.25 0 .396.098.866.418 1.25.338.406.843.617 1.449.617m.466-1.867c0 .188-.048.3-.093.354-.026.031-.104.113-.373.113-.27 0-.348-.082-.374-.113-.044-.054-.093-.166-.093-.354s.049-.3.093-.354c.026-.03.105-.112.374-.112s.347.081.373.112c.045.054.093.167.093.354"
                fill="currentColor"
            />
            <path
                d="m4.332 5.675.838-.838.99.99-.838.838.838.838-.99.99-.838-.838-.838.838-.99-.99.838-.838-.838-.838.99-.99z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 7.647C0 3.412 1.333 2 5.333 2h5.334C14.667 2 16 3.412 16 7.647v2.647C16 12.941 14.998 14 13.667 14c-.93 0-1.642-.608-2.406-1.26-.882-.753-1.832-1.563-3.261-1.563s-2.379.81-3.26 1.563C3.976 13.392 3.263 14 2.333 14 1.002 14 0 12.941 0 10.294zm1.4 0c0-2.053.343-2.983.784-3.45.42-.444 1.242-.797 3.15-.797h5.333c1.907 0 2.73.353 3.149.797.441.467.784 1.397.784 3.45v2.647c0 1.18-.229 1.778-.414 2.043-.136.194-.275.263-.52.263-.147 0-.324-.046-.604-.223-.267-.17-.524-.389-.882-.694l-.192-.163C11.145 10.806 9.884 9.776 8 9.776s-3.145 1.03-3.988 1.744q-.1.086-.192.163c-.358.305-.615.524-.882.694-.28.177-.457.223-.605.223-.243 0-.383-.07-.519-.263-.185-.265-.414-.862-.414-2.043z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GamepadOutlinedSize16Glyph.displayName = 'GamepadOutlinedSize16Glyph';
